import React, { useState, useEffect, useContext } from 'react';
import withAppContext from 'tbk-components/src/hooks/withAppContext';
import Loading from 'tbk-components/src/components/Loading';
import InvestorsFeaturedBox, {
	IInvestorsFeaturedBoxProps,
} from '../InvestorsFeaturedBox';
import { IBaseElementProps } from 'tbk-components/src/components/BasicElement';
import { ILink } from 'tbk-components/src/components/Button';
import Button from 'tbk-components/src/components/Button';

export interface IEventFeaturedBoxProps extends IBaseElementProps {
	/**
	 * Intro text (leave blank to not have anything show up)
	 */
	introText?: string;
	/**
	 * Which event to show (recent = most recent, next = next upcoming, last = most recent archived event). Defaults to upcoming.
	 */
	eventType?: 'recent' | 'next' | 'last';
	/**
	 * Event data
	 * @noUI
	 */
	defaultFeaturedBoxData?: IInvestorsFeaturedBoxProps;
	/**
	 * Set an optional link under the event information. Displays as a button.
	 */
	link?: ILink;
	backgroundStyle?: 'Gradient' | 'Solid';
}

/**
 * Automatic Featured Event Box
 * @block
 * @icon calendar-alt
 */
export const EventFeaturedBox: React.FC<IEventFeaturedBoxProps> =
	withAppContext(
		({
			introText,
			eventType,
			defaultFeaturedBoxData,
			backgroundStyle = 'Gradient',
			link,
			id,
			className,
			classNames = [],
			context,
		}) => {
			const { Api } = useContext(context);
			const [featuredBoxData, setFeaturedBoxData] =
				useState<IInvestorsFeaturedBoxProps>(null);
			const [loading, setLoading] = useState<boolean>(false);

			// Update on prop changes in editor or on initial load.
			useEffect(() => {
				if (defaultFeaturedBoxData) {
					setFeaturedBoxData(defaultFeaturedBoxData);
				} else {
					setLoading(true);
					Api.getEventFeaturedBoxData({ eventType: eventType })
						.then(({ featuredBoxData }) => {
							setFeaturedBoxData(featuredBoxData);
						})
						.finally(() => setLoading(false));
				}
			}, [defaultFeaturedBoxData, eventType]);
			return loading ? (
				<Loading />
			) : (
				<>
					<InvestorsFeaturedBox
						{...featuredBoxData}
						link={link}
						date={introText ? introText : featuredBoxData?.date}
						id={id}
						className={className}
						classNames={classNames}
						backgroundStyle={backgroundStyle}
						subheading={
							introText && featuredBoxData?.date
								? featuredBoxData?.date
								: introText
						}
					/>
				</>
			);
		},
	);

export default EventFeaturedBox;
